import { Box, Card, Container, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import clsx from 'clsx';
import { defaultCompanyLogo } from 'config';
import { Company } from 'graphql/generated';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyle } from './company-header.style';

type CompanyHeaderProps = {
    company: Company;
};

export const CompanyHeader: React.FC<CompanyHeaderProps> = ({ company: { name, logo, region, verified } }) => {
    const classes = useStyle();
    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            <Container maxWidth="lg">
                <div className={classes.leftSide}>
                    <Card className={clsx(classes.logo, !logo?.url && classes.defaultLogo)}>
                        <img src={logo?.url || defaultCompanyLogo} alt="company logo" />
                    </Card>
                    <div className={classes.detail}>
                        <Typography variant="h3" className={classes.name}>
                            {name}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" className={classes.region}>
                            {t(`region:${region.name}`)}
                        </Typography>
                        {verified && (
                            <Card className={classes.verified}>
                                <Box className={classes.verifiedIcon}>
                                    <CheckIcon style={{ fontSize: 16 }} />
                                </Box>
                                <Typography style={{ padding: '0 10px' }} variant="body2">
                                    {t('companyList:verified')}
                                </Typography>
                            </Card>
                        )}
                    </div>
                </div>
            </Container>
        </div>
    );
};
